import { Box } from '@mui/material';
import React from 'react'
import ImportMegToPipedriveBDC from './ImportMegToPipedriveBDC';
import TabbedView from '../../../components/TabbedView';

function ImportMain() {
 const tabs = [
    {
      label: 'Bons de commande',
      content: <ImportMegToPipedriveBDC />,
    },
    {
      label: 'Factures',
      content: <Box>Contenu des utilisateurs</Box>,
    }
  ];

  return (
    <Box>
        <TabbedView tabs={tabs} />
    </Box>
  );
}

export default ImportMain